/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_DetailsInputs */

const en_company_details = /** @type {(inputs: Company_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Details`)
};

const de_company_details = /** @type {(inputs: Company_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensdetails`)
};

/**
* | output |
* | --- |
* | "Company Details" |
*
* @param {Company_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_details = /** @type {((inputs?: Company_DetailsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_DetailsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_details(inputs)
	return en_company_details(inputs)
});